<template>
    <div>
        <jd-dialog title="设置标签" :visible.async="visible" width="1010px" @close="taskClose" @comfirm="sureTask">
            <div style="margin-bottom: 20px;">请选择当前商品适合的标签</div>
            <el-form :model="form" label-width="100px">
                <div v-for="(question, index) in questionList" :key="index">
                <el-form-item :label="'题目'+(index+1)+'：'">
                    <el-checkbox-group v-model="form.tags">
                        <el-checkbox v-for="(item, i) in question.options" :key="i+'options'" :label="item.uuid">
                           <span v-if="question.type == 1">  {{item.description}}</span>
                           <span v-if="question.type == 4"> 
                            <img :src="item.picUrl" style="width: 50px; height: 50px;" alt="">
                           </span>
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                </div>
            </el-form>
        </jd-dialog>
    </div>
</template>
<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        questionList: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        visible(newVal, oldVal) {
            if (newVal) {
            }
        }
    },
    data() {
        return {
            form: {
                tags: []
            }
        }
    },
    methods: {
        taskClose() {
            this.$emit('close');
        },
        sureTask() {
            this.$emit('comfirm', this.form.tags);
        }
    }
}
</script>
<style lang="scss" scoped>
</style>